import React from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { getPublicUrl } from "../../utils/runtimeUrls";

import TicketsManager from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import { i18n } from "../../translate/i18n";
import logoWhiteAsset from "../../assets/logo_white.png";
import logoDarkAsset from "../../assets/logo.png";

const useStyles = makeStyles(theme => ({
	chatContainer: {
		flex: 1,
		// backgroundColor: "#eee",
		padding: theme.spacing(0), //Aqui ele ajusta espaço na tela de ticket
		height: `100%`,
		overflowY: "hidden",
	},

	chatPapper: {
		// backgroundColor: "red",
		display: "flex",
		height: "100%",
	},

	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
		minWidth: 0,
	},
	messagesWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		minWidth: 0,
	},
	welcomeMsg: {
		backgroundColor: theme.palette.boxticket, //DARK MODE PLW DESIGN//
		display: "flex",
		justifyContent: "space-evenly",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
	},
}));

const randomValue = Math.random(); // Generate a random number
const logoLightUrl = `${getPublicUrl("public/logotipos/login.png")}?r=${randomValue}`;
const logoWhiteUrl = `${getPublicUrl("public/logotipos/login_white.png")}?r=${randomValue}`;

const TicketsCustom = () => {
	const classes = useStyles();
	const theme = useTheme();
	const isDark = theme.palette.type === "dark";
	const { ticketId } = useParams();

	return (
		<div className={classes.chatContainer}>
			<div className={classes.chatPapper}>
				<Grid container spacing={0}>
					<Grid item xs={12} md={5} lg={4} className={classes.contactsWrapper}>
						<TicketsManager />
					</Grid>
					<Grid item xs={12} md={7} lg={8} className={classes.messagesWrapper}>
						{ticketId ? (
							<>
								<Ticket />
							</>
						) : (
							<Paper square variant="outlined" className={classes.welcomeMsg}>
							<div>
							<center>
								<img
									style={{ margin: "0 auto", width: "80%" }}
									src={isDark ? logoWhiteUrl : logoLightUrl}
									onError={e => {
										e.target.onerror = null;
										e.target.src = isDark ? logoWhiteAsset : logoDarkAsset;
									}}
									alt={`${process.env.REACT_APP_NAME_SYSTEM}`}
								/>
							</center>
							</div>
							{/*<span>{i18n.t("chat.noTicketMessage")}</span>*/}
							</Paper>
						)}
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default TicketsCustom;
